import { render, staticRenderFns } from "./EnergyUtilization.vue?vue&type=template&id=2ef3aea8&scoped=true&"
import script from "./EnergyUtilization.vue?vue&type=script&lang=ts&"
export * from "./EnergyUtilization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3aea8",
  null
  
)

export default component.exports